module.exports = __webpack_public_path__ + "a823243f52ceee90103ae23fe257f8ac.pdf";